import { useState } from 'react';
import ImageGallery from 'react-image-gallery';
import GalleryLoaderSkeleton from './GalleryLoaderSkeleton';

const Gallery = ({ images, thumbnails }) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  let gallery = [];
  images.forEach((image, index) => {
    gallery.push({
      original: image,
      thumbnail: thumbnails[index],
      loading: 'lazy',
    });
  });
  return (
    <>
      {!imageLoaded && <GalleryLoaderSkeleton />}
      <ImageGallery
        items={gallery}
        thumbnailPosition="right"
        onImageLoad={() => setImageLoaded(true)}
        lazyLoad={true}
        showNav={imageLoaded ? true : false}
        showFullscreenButton={imageLoaded ? true : false}
        showPlayButton={imageLoaded ? true : false}
        onErrorImageURL="https://clubdynasty.ca/wp-content/uploads/2020/09/Untitled.jpg"
      />
    </>
  );
};

export default Gallery;
